<template lang="pug">
div(
    data-page-type="banner"
    class="affirm-site-modal"
)
    slot
</template>

<script>
import { refreshAffirm } from './refreshAffirm'

export default {
    name: 'AffirmRatesWrapper',
    mounted() {
        this.$affirm.load(refreshAffirm)
    },
}
</script>
